module.exports = __webpack_public_path__ + "4a79a2c70580f0c30a85cbb3e71be6e2.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/heros/api-app.png
// module id = 627
// module chunks = 0